import * as React from "react"
import { router, usePage } from "@inertiajs/react"
import type { PageProps } from "@/types/inertia"
import "@/styles/public-account.css"

// The one-time flash on every public page (M6, made global in M7): the
// sign-up welcome, "We've added … to your account", the verification
// results, "Design duplicated…", "You don't have access to that page." and
// the brochure link's expiry. Rendered once, by PublicShell, as a note docked
// under the fixed header (right-hand side from 720px), so it reads on any
// page whatever its hero. Each note can be dismissed; the next visit's flash
// shows again.
export function FlashMessages() {
  const { props } = usePage<PageProps>()
  const notice = props.flash?.notice
  const alert = props.flash?.alert
  const [dismissed, setDismissed] = React.useState<{ notice: boolean; alert: boolean }>({
    notice: false,
    alert: false,
  })

  React.useEffect(() => router.on("navigate", () => setDismissed({ notice: false, alert: false })), [])

  const showAlert = Boolean(alert) && !dismissed.alert
  const showNotice = Boolean(notice) && !dismissed.notice
  if (!showAlert && !showNotice) return null

  return (
    <div className="flash-dock">
      {showAlert && (
        <div role="alert" className="flash-note flash-note-alert">
          <span>{alert}</span>
          <DismissButton onClick={() => setDismissed((value) => ({ ...value, alert: true }))} />
        </div>
      )}
      {showNotice && (
        <div role="status" className="flash-note">
          <span>{notice}</span>
          <DismissButton onClick={() => setDismissed((value) => ({ ...value, notice: true }))} />
        </div>
      )}
    </div>
  )
}

function DismissButton({ onClick }: { onClick: () => void }) {
  return (
    <button type="button" className="flash-dismiss" onClick={onClick} aria-label="Dismiss message">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
        <path d="M1 1l10 10M11 1L1 11" stroke="currentColor" strokeWidth="1.3" />
      </svg>
    </button>
  )
}
